// src/store/modules/firstPickup/index.js
import * as actions from "./actions";

const state = {
  firstPickupList: [],
};

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/firstPickup/index.js